<template>
  <el-row :gutter="20">
    <el-col :span="24">
  	<h2>{{ $t('title.edit-switch') }}</h2>
    </el-col>

    <el-col :span="12">

      <switch-form :switchx="switchx" />

    </el-col>

    <el-col :span="12">

      <server-switch-form :switchx="switchx" />

    </el-col>

  </el-row>
</template>

<script>
import SwitchForm from './SwitchForm'
import ServerSwitchForm from './ServerSwitchForm'

export default {
  name: 'switch-details',
  computed: {
    switchx () {
      const id = this.$route.params.id

      return this.$store.getters['switches/findById'](id, this.$store.dispatch)
    }
  },
  components: {
    SwitchForm,
    ServerSwitchForm
  }
}
</script>



// WEBPACK FOOTER //
// SwitchDetails.vue?bbdcd0ac